import { ConnectionType, IConnectionDetailsDTO } from '../../api/connections.dao';
import { FormViewModelController, FormViewModelItemState } from '../../infrastructure/form-viewmodel-controller';
import CONNECTION_CONFIG from './event-connection-config';
import { ConnectionFields as Fields } from './config';
import {
    AudioBridgeConnectionFormVm
} from '../../components/_events/_manage-event/shared/connections-list/_connection-form/connection-form-body/audio-bridge-connection-form/audio-bridge-connection.form-vm';
import { AbstractFormViewModelController } from '../../infrastructure/implementations/form-viewmodel-controller';
import { PanelistLinkConnectionFormVm } from '../../components/_events/_manage-event/shared/connections-list/_connection-form/connection-form-body/panelist-link-connection-form/panelsit-llink-connection.form-vm';


interface IConnectionFormViewModelController extends FormViewModelController {
    meetingConnectionId: number | null;
    blueprintId: string | null;
    type: ConnectionType;
    getVmFields(): FormViewModelItemState[];
    isExistingConnection(): boolean;
    toApiDTO(): IConnectionDetailsDTO;
}

class ConnectionVmProvider {
    public static createViewModel(connection: IConnectionDetailsDTO): IConnectionFormViewModelController {
        const { type, meetingConnectionId = null, blueprintId, ...initialData } = connection;

        switch (type) {
            case ConnectionType.AudioBridge:
                return AudioBridgeConnectionFormVm.create(connection);

            case ConnectionType.PanelistLink:
                return PanelistLinkConnectionFormVm.create(connection);

            /* TODO: Remove default statement after every Connections will be created via own ViewModel */
            default:
                 return new class extends AbstractFormViewModelController {
                    public readonly meetingConnectionId: number | null = meetingConnectionId;
                    public readonly blueprintId: string | null = blueprintId;
                    public readonly type: ConnectionType = type;

                    constructor() {
                        super(initialData, `${type} Connection Type`, CONNECTION_CONFIG[type]);
                    }

                    public getVmFields = () => this.getVmState();

                    public isExistingConnection = (): boolean => this.meetingConnectionId !== null;

                    public toApiDTO = (): IConnectionDetailsDTO => {
                        const dto: IConnectionDetailsDTO = { type: this.type, blueprintId: this.blueprintId };

                        if (this.isExistingConnection()) {
                            dto[Fields.MEETING_CONNECTION_ID] = this.meetingConnectionId;
                        }

                        return this.getVmState()
                        .reduce((_dto, { name, value }) => {
                            const booleanValue = typeof value === 'boolean';
                            const trimmedValue = booleanValue
                                ? value
                                : String.prototype.trim.call(value || '');

                            if (booleanValue || trimmedValue) _dto[name] = trimmedValue;

                            return _dto;
                        }, dto);
                    };

                }();
        }

    }
}


export {
    IConnectionFormViewModelController,
    ConnectionVmProvider,
};
